import { Trans } from '@lingui/react/macro';

import { ArticleWithRelations } from '@/models/request';

import { BaseMessage } from './BaseMessage';

export const QualityControlStepMessage = ({ article }: { article: ArticleWithRelations }) => {
  return (
    <BaseMessage
      title={
        <Trans id="article.step-message.quality-control">
          The item is currently in quality control
        </Trans>
      }
      message={null}
      article={article}
    />
  );
};
